/*
 * Description: Input Textarea Field Web Component
 * Purpose: A reusable textarea component for multi-line text input
 * Author: Nuvemx
 * Created: 2026
 *
 * Features:
 * - Displays a label for the textarea field
 * - Supports placeholder, rows, and cols attributes
 * - Designed to be embedded within other components
 *
 * Usage:
 * <input-textarea-field label="Description" placeholder="Enter text..." rows="4"></input-textarea-field>
 *
 * Attributes:
 * - label: String - The label/name to display for this textarea
 * - placeholder: String - Placeholder text
 * - value: String - Initial value
 * - rows: Number - Number of visible text rows (default: 4)
 * - cols: Number - Number of visible text columns (default: 50)
 */

class input_textarea_field extends HTMLElement {
    connectedCallback() {
        if (this.dataset.rendered) {
            return;
        }
        const label = this.getAttribute("label") || "Textarea";
        const placeholder = this.getAttribute("placeholder") || "";
        const value = this.getAttribute("value") || "";
        const rows = this.getAttribute("rows") || "4";
        const cols = this.getAttribute("cols") || "50";
        const fieldId = `textarea-field-${Math.random().toString(36).substr(2, 9)}`;

        this.innerHTML = `<div class="form-outline mb-3">
                            <textarea id="${fieldId}" class="form-control" placeholder="${placeholder}" rows="${rows}" cols="${cols}">${value}</textarea>
                            <label class="form-label" for="${fieldId}">${label}</label>
                          </div>`;
        this.dataset.rendered = "true";
    }
}

export { input_textarea_field };
